module.exports = __webpack_public_path__ + "assets/img/Type E (11).83200f6e.jpg";